import React from 'react';
import HeaderVariantType from '../types/HeaderVariantType';

type HeaderContextProps = {
  headerVariant: HeaderVariantType;
  showMenu: boolean;
  setShowMenu: (isActive: boolean) => void;
};

export default React.createContext<HeaderContextProps>({
  headerVariant: HeaderVariantType.Basic,
  showMenu: false,
  setShowMenu: () => {
    // do nothing.
  },
});
